import React from 'react';
import NavBarFixed from '../components/Navbar/NavbarFixed.js';
import Hero from '../components/Hero.js';
import Features from '../components/Features.js';
import EarnCredits from '../components/EarnCredits.js';
import Footer from '../components/Footer.js';
import Contact from '../components/Contact.js';


const Home = () => {
    return (
        <>
		    <NavBarFixed />
            <Hero />
			<Features />
			<EarnCredits />
            <Contact />
            <Footer />
        </>

    )
}

export default Home;
